<template>
  <section class="news-page">
    <router-link to="/#ajankohtaista" class="news-back-link">← Takaisin etusivulle</router-link>
    <article v-if="article" class="news-article">
      <header>
        <div class="news-meta">
          <time v-if="article.publishedAt" :datetime="article.publishedAt">{{ formatNewsDate(article.publishedAt) }}</time>
          <span v-else>{{ formatNewsDate(null) }}</span>
          <span v-if="article.resolvedOn && article.resolvedOn <= today" class="news-resolved">Korjattu {{ formatNewsDate(article.resolvedOn) }}</span>
        </div>
        <h1>{{ article.title }}</h1>
      </header>
      <p v-if="!article.publishedAt" class="news-archive-note">Julkaisupäivä ei ole tiedossa. Alkuperäinen merkintä: {{ article.originalDateLabel }}.</p>
      <p v-else-if="article.category === 'period'" class="news-archive-note">Jaksouutinen kuvaa julkaisuhetken tilannetta. Nykyisen jakson ja vaihtojen tilanteen näet sivun yläosasta.</p>
      <div class="news-article-body">
        <p v-for="(paragraph, index) in article.paragraphs" :key="index">{{ paragraph }}</p>
      </div>
      <footer class="news-article-footer">
        <router-link :to="isAuthenticated ? '/#ajankohtaista' : '/'" class="news-home-cta">{{ isAuthenticated ? 'Takaisin etusivulle' : 'Tutustu Raviremmiin' }} →</router-link>
        <div class="news-secondary-links">
          <router-link to="/uutiset" class="news-read-link">Aiemmat uutiset</router-link>
          <router-link v-if="article.relatedPeriodStart" :to="{ path: '/results', query: { view: 'archive', start: article.relatedPeriodStart } }" class="news-read-link">Katso jakson lopputulokset</router-link>
          <router-link v-else-if="article.category === 'update'" to="/introduction" class="news-read-link">Peliohjeet</router-link>
        </div>
      </footer>
    </article>
    <div v-else class="news-empty">
      <h1>Uutista ei löytynyt</h1>
      <p>Uutinen ei ole saatavilla. Löydät julkaistut uutiset uutisarkistosta.</p>
      <router-link to="/#ajankohtaista" class="news-home-cta">Takaisin etusivulle →</router-link>
    </div>
  </section>
</template>

<script setup>
/* global defineProps */
import { computed, inject, ref } from 'vue';
import { getPublishedNews, formatNewsDate } from '../utils/news';
import { useNewsDate } from '../composables/useNewsDate';
const props = defineProps({ slug: { type: String, required: true } });
const today = useNewsDate();
const isAuthenticated = inject('isAuthenticated', ref(false));
const article = computed(() => getPublishedNews(today.value).find(item => item.slug === props.slug));
</script>

<style src="../styles/news.css"></style>
